<section class="hero-bg text-center pb-24 pt-12">
 <div class="hero-content pt-15">
 <div class="hero-badge text-white rounded-lg">
  <span class="badge-text">
    <span class="text-(--color-main)">404</span>
  </span>
</div>

 <div class="hero-title pt-5 ">
    <h1 class="text-white"> الصفحة غير متوفرة
    </h1>

    <p class="hero-description text-white py-5">
      يبدو أن هذه الصفحة غير متواجدة يمكنك العودة <br>إلى الصفحة الرئيسية للإكتشاف فرص إستثمارية.
    </p>
  </div>
 </div>




  <button
  routerLink="/"
    class="bg-(--color-main) text-(--color-secondary) h-12 px-12  rounded-[10px]
           font-semibold transition-all hover:bg-(--color-main-20) hover:text-(--color-main) cursor-pointer"

  >
  العودة إلى الصحفة الرئيسية
  </button>

</section>
